// Lecture du seuil de validation PDG, cote interface.
//
// L'affichage est purement indicatif : c'est workflowService, cote serveur, qui
// tranche au moment du visa de l'assistante. Cette table ne sert qu'a prevenir
// l'utilisateur, jamais a decider.

export const SEUIL_PAR_DEFAUT = 5000000;

// Un seuil absent signifie « aucun allegement » : tout remonte au PDG. La regle
// est la meme que dans backend/src/services/workflowService.js.
export const sousLeSeuil = (montant, seuil) => {
  if (seuil === null || seuil === undefined || seuil === '') return false;
  const s = Number(seuil);
  if (Number.isNaN(s)) return false;
  return Number(montant || 0) < s;
};

// Le seuil applicable a une filiale, depuis la liste deja chargee par la page.
export const seuilDeFiliale = (filiales, filialeId) => {
  const f = (filiales || []).find((x) => (x._id || x.id) === filialeId);
  return f?.seuil_pdg ?? null;
};

// Message affiche a la saisie du montant.
export const messageSeuil = (montant, seuil) => {
  if (seuil === null || seuil === undefined || seuil === '') return null;
  if (!Number(montant)) return null;
  return sousLeSeuil(montant, seuil)
    ? {
      ton: 'neutre',
      texte: 'Cette demande sera traitée sans validation PDG.',
      detail: `Seuil de la filiale : ${Number(seuil).toLocaleString('fr-FR')} FCFA.`,
    }
    : {
      ton: 'info',
      texte: 'Cette demande nécessitera la validation du PDG.',
      detail: `Montant supérieur ou égal au seuil de ${Number(seuil).toLocaleString('fr-FR')} FCFA.`,
    };
};

// Pastille affichee a cote du montant sur le detail d'une demande.
export const badgeSeuil = (montant, seuil) => (sousLeSeuil(montant, seuil)
  ? { libelle: 'Sans validation PDG', couleur: '#555', fond: '#F2F3F4' }
  : { libelle: 'Avec validation PDG', couleur: '#1A5E8A', fond: '#EAF4FB' });
